<template>
    <div style="padding:20px;">
        <h3>Ошибка - обновите страницу!</h3>
    </div>
</template>

<script>
    export default {

    };
</script>

<style scoped>
</style>